import { createRouter, createWebHistory } from 'vue-router';
export default createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', redirect: '/open-portal/index' },
    { path: '/open-portal/login', component: () => import('@/views/open-portal/login.vue'), name: 'OpenPortalLogin' },
    { path: '/open-portal/index', component: () => import('@/views/open-portal/index.vue'), name: 'OpenPortal' },
    { path: '/open-portal/admin', component: () => import('@/views/open-portal/admin/index.vue'), name: 'OpenPortalAdmin' },
    { path: '/open-portal/admin/applications', component: () => import('@/views/open-portal/admin/ApplicationsAdmin.vue'), name: 'OpenPortalApplicationAdmin' },
    { path: '/:pathMatch(.*)*', redirect: '/open-portal/index' }
  ]
});
